import { createTranslations } from '../../../shared/config/i18n';

export const translations = createTranslations({
  signInView: {
    title: {
      id: 'sign-in-page-title',
      defaultMessage: 'Sign in.',
    },
    leftTitle1: {
      id: 'sign-in-page-left-title-1',
      defaultMessage:
        'The most powerful platform to search and sample materials.',
    },
    leftTitle2: {
      id: 'sign-in-page-left-title-2',
      defaultMessage: 'Hundreds of\nleading brands.\nOne site.',
    },
    leftTitle3: {
      id: 'sign-in-page-left-title-3',
      defaultMessage: 'Order by midnight.\nSamples tomorrow.',
    },
    leftTitle4: {
      id: 'sign-in-page-left-title-4',
      defaultMessage: 'Everything in one box.\nDelivered the next day.',
    },
    emailPlaceholder: {
      id: 'sign-in-page-email-placeholder',
      defaultMessage: 'Business email',
    },
    incorrectEmailOrPassword: {
      id: 'sign-in-page-incorrect-email-or-password',
      defaultMessage: 'Incorrect email or password.',
    },
    resetPassword: {
      id: 'sign-in-page-reset-password',
      defaultMessage: 'Reset password',
    },
    agreementText: {
      id: 'sign-in-page-agreement-text',
      defaultMessage:
        'By clicking "Sign in", you agree to Our {termsOfUse} and {privacyPolicy}',
    },
    termsOfUse: {
      id: 'sign-in-page-terms-of-use',
      defaultMessage: 'Terms of Use',
    },
    privacyPolicy: {
      id: 'sign-in-page-privacy-policy',
      defaultMessage: 'Privacy Policy',
    },
    submitButtonText: {
      id: 'sign-in-page-submit-button-text',
      defaultMessage: 'Sign in',
    },
    forgotPassword: {
      id: 'sign-in-page-forgot-password',
      defaultMessage: 'Forgot password?',
    },
  },
});
